import { render, staticRenderFns } from "./FiltroHeaderUnidade.vue?vue&type=template&id=24a1e5b2"
import script from "./FiltroHeaderUnidade.vue?vue&type=script&lang=js"
export * from "./FiltroHeaderUnidade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports